import { formatLastBuiltDate } from "@/lib/date.ts";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const STATUS_TO_COLOR_MAP = {
  failed: "red",
  building: "orange",
  built: "green",
};

const getStatusColor = (status: string) =>
  STATUS_TO_COLOR_MAP[status as keyof typeof STATUS_TO_COLOR_MAP] ?? "gray";

const STATUS_TO_TEXT_MAP = {
  failed: "Knowledge Base Failed",
  building: "Knowledge Base Building",
  built: "Knowledge Base Built",
};

const getStatusText = (status: string) =>
  STATUS_TO_TEXT_MAP[status as keyof typeof STATUS_TO_TEXT_MAP] ??
  "No Knowledge Base Found";

export function PersonaKnowledgeBaseStatus({
  status,
  lastBuilt,
  className,
}: {
  status: string;
  lastBuilt?: string;
  className?: string;
}) {
  const lastBuiltDate = formatLastBuiltDate(lastBuilt);

  return (
    <p className={className}>
      <Tooltip delayDuration={100}>
        <TooltipTrigger>
          <p style={{ color: getStatusColor(status) }}>
            {getStatusText(status)}
          </p>
        </TooltipTrigger>
        {lastBuiltDate ? (
          <TooltipContent
            // Open to the bottom to avoid overlapping with the "Upload Avatar" button
            side="bottom"
          >
            Last Built: {lastBuiltDate}
          </TooltipContent>
        ) : null}
      </Tooltip>
    </p>
  );
}
